import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: ({ path, spec: { meta } }) => {
      if (meta?.file || meta?.select) {
        return `${path}を選択してください`;
      } else {
        return `${path}を入力してください`;
      }
    },
  },
});

const MAX_FILE_SIZE = 1024 * 1024 * 10;

const maxFileSizeValidator = (value: File | undefined, max: number) => {
  if (!value) return true;
  return value.size < max;
};

yup.addMethod<yup.MixedSchema>(yup.mixed, 'fileSize', function fileSize() {
  return this.file().test(
    'fileSize',
    ({ label }) => `${label}にアップロードできるファイル容量は10MB迄です。ご確認の上、再度アップロードください。`,
    (value?: File | {}) => {
      if (!value) return true;
      if (!(value instanceof File)) return true;

      return maxFileSizeValidator(value, MAX_FILE_SIZE);
    },
  );
});

yup.addMethod<yup.MixedSchema>(yup.mixed, 'file', function file() {
  return this.meta({ file: true });
});

declare module 'yup' {
  interface MixedSchema {
    fileSize(): MixedSchema<File>;
    file(): MixedSchema;
  }
}

export { yup };
